import dayjs from 'dayjs';

export const formatDate = (date, format) =>
  date ? dayjs(date).format(format) : null;
